import script from "./DynamicScrollerTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicScrollerTable.vue?vue&type=script&setup=true&lang=ts"

import "./DynamicScrollerTable.vue?vue&type=style&index=0&id=984d7358&scoped=true&lang=css"
import "./DynamicScrollerTable.vue?vue&type=style&index=1&id=984d7358&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-984d7358"]])

export default __exports__